// eslint-disable-next-line import/prefer-default-export
export enum COMMON_GRID_COLUMN_FIELD_NAMES {
    Action = 'action',
}

export enum COMMON_GRID_ACTION {
    View = 'view',
    Edit = 'edit',
    Delete = 'delete',
    Download = 'download',
    Restore = 'restore',
    Reschedule = 'reschedule',
    Pause = 'pause',
    Resume = 'resume',
    Start = 'start',
    Stop = 'stop',
    Trash = 'trash',
    Untrash = 'untrash',
    Reprovision = 'reprovision'
}

export enum ROWSELECTION {
    SINGLE = 'single',
    MULTIPLE = 'multiple',
}
